import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSuperAdminUserRole } from "../../../../context/SuperAdmin/UserRoleContext";
import { useAuthContext } from "../../../../hooks/Auth";

const HeadersUsersRole = () => {
  const {
    toggleDeleteModal,
    toggleAddModal,
    toDeleteUsers,
    searchQuery,
    handleSearchQuery,
  } = useSuperAdminUserRole();
  const { canAccess } = useAuthContext();

  return (
    <Grid
      container
      spacing={4}
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Grid item xs={6}>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Buscar usuarios por nombre o email..."
          fullWidth
          value={searchQuery}
          onChange={(e) => handleSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        display={"flex"}
        justifyContent={"flex-end"}
        spacing={2}
        gap={2}
      >
        {canAccess("delete:roleUsers") && (
          <Button
            variant="outlined"
            onClick={() => toggleDeleteModal(true)}
            disabled={!toDeleteUsers.length}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Eliminar
          </Button>
        )}
        {canAccess("create:roleUsers") && (
          <Button
            variant="contained"
            onClick={() => toggleAddModal(true)}
            sx={{ background: "#336B87" }}
          >
            Agregar Usuarios
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default HeadersUsersRole;
